/**
 * One dashboard counter (M23-T03), drawn on `1181:4442`: a display-size number,
 * a label, a rule, then a footer line — a bold age and a plain explanation.
 *
 * **The count and the footer come from one prop each and are rendered
 * together.** The frame draws a tile reading `2` above the footer "No requests"
 * (M23 defect D7). That contradiction is only reachable when the two are
 * sourced separately, so this component derives the empty footer from the count
 * itself rather than trusting the caller to keep them in step.
 */
export function StatCard({
  count,
  label,
  age,
  note,
  emptyNote = 'No requests',
}: {
  count: number
  label: string
  /** e.g. `14d` — the age of the oldest item still waiting. */
  age?: string
  /** e.g. `oldest not yet secured`. Shown beside `age`. */
  note?: string
  /** Shown instead, whenever `count` is 0. */
  emptyNote?: string
}) {
  const empty = count === 0
  return (
    <div className="flex flex-col rounded-2xl border border-line-1 bg-bg-app p-5">
      <p className="font-display text-3xl font-semibold leading-none text-ink-1">
        {count}
      </p>
      <p className="mt-3 text-sm text-ink-2">{label}</p>
      <hr className="mt-3 border-line-1" />
      <p className="mt-3 text-sm text-ink-3">
        {empty || age === undefined ? (
          emptyNote
        ) : (
          <>
            <span className="font-semibold text-ink-1">{age}</span>
            {note !== undefined && ` ${note}`}
          </>
        )}
      </p>
    </div>
  )
}
